
import { InterpolationWithTheme } from "@emotion/core";
import { css } from 'emotion';


export const RosterCalendarStyles: { [key: string]: InterpolationWithTheme<any> } = {
    rosterOuterContainer: {
        display: "flex",
        justifyContent: "left",
        flexWrap: "wrap",
        boxShadow: "0 2px 8px 0 rgb(151,151,151)",
        marginBottom: "40px"
    },
    rosterCalendarLabel: {
        paddingLeft: "15px",
        lineHeight: "35px",
        color: "rgb(0,0,0)",
        fontFamily: "BrandonTextWeb-Regular",
        boxShadow: " 0 0 0 1px rgb(151,151,151)",
        margin: "0 0 1px 1px",
        background: "rgba(222, 236, 253, 0.5)",
        fontSize: "14px"
    },
    calendarDayLabel: {
        lineHeight: "35px",
        color: "rgb(0,0,0)",
    },
    rosterCard: {
        minHeight: "282px",
        flex: 1,
        background: "white",
        boxShadow: "0 0 0 1px rgb(151,151,151)",
        margin: "0 0 1px 1px",
        borderRadius: 0,
        minWidth: "unset",
        maxWidth: "unset"
    },
    rosterWrapper: {
        paddingBottom: "30px",
        margin: "0px 35px",
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        fontFamily: "BrandonTextWeb-Regular",
        boxShadow: " 0 0 0 1px rgb(151,151,151)",
        margin: "0 0 1px 1px",
        background: "rgba(222, 236, 253, 0.5)",
        padding: "0px 15px"
    },
    editWrapper: {
        marginTop: "7px",
        cursor: "pointer"
    },
    editImg: {
        height: "14px"
    },
    editLabel: {
        color: "#ff316d",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "12px",
        paddingLeft: "5px"
    },
    copyRosterWrapper: {
        display: "flex",
        justifyContent: "left",
        flexWrap: "wrap"
    }

}

export const rosterInnerContainer = css`
    width: calc((100%) / 7);
    &:first-of-type {
        border-top-left-radius: 5px;
    };
    &:last-of-type {
        border-top-right-radius: 5px
    };
`;

export const rosterButtonStyles = {
    display: "inline",
    fontSize: 14,
    padding: "10px 50px",
    marginTop: "4px"
}